<template>
	<div class="page" :style="height">
		<div class="searchbar">
			<div class="pr10"></div>
			<el-form ref="form" :model="query" :inline="true" label-width="74px" size="small" :show-message="false"
				class="search-form">
				<el-form-item label="关键字">
					<el-input v-model="query.searchKey2" clearable placeholder="请输入关键字"></el-input>
				</el-form-item>
				<el-form-item label="产品名称">
					<el-cascader
						:options="machineOptions"
						:props="machineProps"
						:show-all-levels="false"
						v-model="query.deviceId"
						filterable
						clearable
						placeholder="请选择产品"
						class="full-width font14">
					</el-cascader>
				</el-form-item>
        <el-form-item label="内容">
					<el-select v-model="query.details" clearable placeholder="请选择内容">
						<el-option v-for="option in contentOptions" :key="option.id" :label="option.name"
							:value="option.id"></el-option>
					</el-select>
				</el-form-item>
				<el-button class="search-btn" @click="getList(1)"></el-button>
				<el-button icon="el-icon-refresh-right" class="refresh-btn" @click="handleReset"></el-button>
			</el-form>
		</div>

		<div class="main-content">
			<el-table ref="table" :row-class-name="tableRowClassName" :header-cell-style="{color:'#444'}" :data="data" border
				v-loading="loading" :cell-style="getCellStyle" @sort-change="handleSortChange"
				:default-sort="defaultSort">
				<el-table-column prop="title" label="主题" min-width="180" show-overflow-tooltip align="left"
					header-align="center">
					<template slot-scope="scope">
						<span v-if="scope.row.status === 0" class="content-title pointer" :class="scope.row.readFlag === 0 ? 'fwb' : ''" @click="edit(scope.row)">
							{{ scope.row.title }} </span>
						<span v-else class="content-title pointer" :class="scope.row.readFlag === 0 ? 'fwb' : ''"
							@click="goToDetail(scope.row)"> {{ scope.row.title }} </span>
					</template>
				</el-table-column>
        <el-table-column prop="detailName" label="内容" width="120" show-overflow-tooltip align="left" header-align="center">
        </el-table-column>
				<el-table-column prop="pubTime" label="发件时间" sortable="custom" width="170" show-overflow-tooltip
					align="center" header-align="center">
					<template slot-scope="scope">
						{{ (scope.row.pubTime && $moment(scope.row.pubTime).format('YYYY-MM-DD HH:mm:ss')) || '' }}
					</template>
				</el-table-column>
				<el-table-column prop="deviceNames" label="产品名称" show-overflow-tooltip align="left"
					header-align="center">
				</el-table-column>
        <el-table-column prop="clickNum" label="点击量" sortable="custom" width="90" align="center" header-align="center">
        </el-table-column>
				<el-table-column label="操作" width="91" align="center" header-align="center">
					<template slot-scope="scope">
						<div class="table-btn-wrapper">
							<el-button
								v-if="isSuperAdmin || isAdmin || (scope.row.status === 0 && perms.includes('material:update'))"
								type="text" plain class="table-btn info-text" @click="edit(scope.row)"> 修改 </el-button>
							<el-button v-if="scope.row.status >= 1"
								type="text" plain class="table-btn info-text" @click="goToDetail(scope.row)"> 详细 </el-button>
							<el-button
								v-if="isSuperAdmin || (scope.row.status === 0 && perms.includes('material:delete'))"
								type="text" plain @click="del(scope.row)" class="table-btn error-text"> 删除 </el-button>
						</div>
					</template>
				</el-table-column>
			</el-table>

			<div class="pagination-wrapper pa25">
				<Pagination :page.sync="query.pageNo" :pageSize.sync="query.pageSize" :total="total"
					@sizeChange="handleSizeChange" @currentChange="handleCurrentChange"></Pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import Pagination from '@/components/Pagination'

	export default {
		components: {
			Pagination
		},
		data() {
			return {
				// 权限
				perms: JSON.parse(window.sessionStorage.getItem('perms')),
				// 查询参数
				query: {
					searchKey2: '',
					deviceId: '',
					details: '',
					pageNo: 1,
					pageSize: 20,
					// 排序字段
					fieldType: '',
					// 排序规则
					orderType: '',
				},
				defaultSort: {
					prop: '',
					order: ''
				},
				total: 0,
				loading: false,
				// 表格数据
				data: [],
				// 内容数据
				contentOptions: [
					{
						id: "1452459980631355394",
						name: "技术报告发布",
					},
					{
						id: "1412319806570958850",
						name: "技术公告发布",
					}
				],
				// 机种机型数据
				machineOptions: [],
				// 机型选项
				machineProps: {
					multiple: false,
					emitPath: false,
					value: 'id',
					label: 'name',
					children: 'children',
					disabled: 'disabled'
				},
				height: ''
			}
		},
		computed: {
			sortProp() {
				return this.defaultSort.prop
			},
			sortOrder() {
				return this.defaultSort.order
			},
			// 是否为超级管理员
			// 是 才能 (删除或编辑各种状态下的通信箱)
			isSuperAdmin() {
				const userInfoStr = window.sessionStorage.getItem('userInfo')
				if (!userInfoStr) return false

				const userInfo = JSON.parse(userInfoStr)
				if (!userInfo) return false
				if (userInfo.superAdminFlag === '1') return true

				return false
			},
			// 是否是管理员
			// 是 才能 (删除或编辑各种状态下的通信箱)
			isAdmin() {
				const userInfoStr = window.sessionStorage.getItem('userInfo')
				if (!userInfoStr) return false

				const userInfo = JSON.parse(userInfoStr)
				if (!userInfo) return false
				if (userInfo.adminFlag === '1') return true

				return false
			}
		},
		watch: {
			sortProp(prop) {
				console.log('sort prop: ', prop)
				if (prop === 'pubTime') {
					this.query.fieldType = 'pub_time'
				} else if (prop === 'clickNum') {
					this.query.fieldType = 'click_num'
				} else {
					this.query.fieldType = ''
				}
			},
			sortOrder(order) {
				console.log('sort order: ', order)
				if (order === 'ascending') {
					this.query.orderType = 'asc'
				} else if (order === 'descending') {
					this.query.orderType = 'desc'
				} else {
					this.query.orderType = ''
				}
			},
		},
		created() {
			// 查询参数复原
			this.query.pageNo = this.$route.params.pageNo || 1
			this.query.searchKey2 = this.$route.params.searchKey2 || ''
			this.query.deviceId = this.$route.params.deviceId || ''
			this.query.details = this.$route.params.details || ''

			// 排序规则复原
			this.defaultSort.prop = this.$route.params.prop || ''
			this.defaultSort.order = this.$route.params.order || ''

			this.$nextTick(() => {
				this.getList()
			})
			this.getMachineOptions()
			this.height = 'min-height: ' + (window.innerHeight - 180) + 'px'
		},
		methods: {
			// NO.隔行变色
			tableRowClassName({
				row,
				rowIndex
			}) {
				if (rowIndex % 2 == 1) {
					return 'blue'
				} else {
					return 'yellow'
				}
			},
			// 重置查询条件
			handleReset() {
				this.query = {
					searchKey2: '',
					deviceId: '',
					details: '',
					pageNo: 1,
					pageSize: 20,
					// 排序字段
					fieldType: '',
					// 排序规则
					orderType: '',
				};

				this.$refs.table.clearSort()
				this.$nextTick(() => {
					this.$set(this.defaultSort, 'prop', '')
					this.$set(this.defaultSort, 'sort', '')
				})

				this.getList();
			},
			// 获取图书馆数据
			getList(page) {
				if (page) this.query.pageNo = page;

				let query = JSON.parse(JSON.stringify(this.query))
				if (this.query.details) {
					query = Object.assign(query, {
						details: [this.query.details]
					})
				}

				this.loading = true;
				let that = this;
				that.$request.post(
					"dataSubjectPageMaterialList",
					true,
					query,
					function (r) {
						if (r.code == "0") {
							that.data = r.data.list
							that.total = r.data.totalCount
						} else {
							that.$message.error(r.msg)
						}
						that.loading = false
					},
					function () {
						that.loading = false
					}
				)
			},
			// 获取所有机型数据
			getMachineOptions(all) {
				let that = this
				that.$request.post(
					"sysModelDeviceAll",
					false, {},
					function (r) {
						if (r.code == "0") {
							that.machineOptions = r.data
						} else {
							that.$message.error(r.msg);
						}
					}
				)
			},
			// 新增
			add() {
				this.$router.push({
					name: 'mailboxAddEdit',
					params: {
						pageNo: this.query.pageNo,
						searchKey2: this.query.searchKey2,
						deviceId: this.query.deviceId,
						details: this.query.details,
						prop: this.defaultSort.prop,
						order: this.defaultSort.order,
						isTech: 1
					}
				})
			},
			// 编辑
			edit(row) {
				this.$router.push({
					name: 'mailboxAddEdit',
					query: {
						id: row.id
					},
					params: {
						pageNo: this.query.pageNo,
						searchKey2: this.query.searchKey2,
						deviceId: this.query.deviceId,
						details: this.query.details,
						prop: this.defaultSort.prop,
						order: this.defaultSort.order,
						isTech: 1
					}
				})
			},
			// 详情页
			goToDetail(row) {
				if (!this.perms.includes('material:detail')) {
					this.$message.error('你所在的代理商没有此权限或者你的区域代理没有此权限，通过通信箱向渠道支援咨询');
					return
				}

        let that = this
				that.$request.post(
					"dataSubjectClick",
					true, {
						id: row.id
					},
					function (r) {
					}
				)

				this.$router.push({
					name: 'techniqueDetail',
					query: {
						id: row.id
					},
					params: {
						pageNo: this.query.pageNo,
						searchKey2: this.query.searchKey2,
						deviceId: this.query.deviceId,
						details: this.query.details,
						prop: this.defaultSort.prop,
						order: this.defaultSort.order,
						isTech: 1
					}
				})
			},
			// 删除
			del(row) {
				this.$confirm('是否删除当前主题?', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(() => {
					let that = this
					that.$request.post(
						'dataSubjectDelete',
						true, {
							id: row.id
						},
						function (r) {
							if (r.code == "0") {
								that.getList()
								that.$message.success('删除成功')
							} else {
								that.$message.error(r.msg)
							}
						}
					)
				}).catch(() => {})
			},
			handleExport() {
				let that = this
				that.$request.post(
					"dataSubjectExport",
					true,
					that.query,
					function (res) {
						if (res.code == '0') {
							const linkNode = document.createElement('a');
							linkNode.style.display = 'none';
							linkNode.href = res.data;
							document.body.appendChild(linkNode);
							linkNode.click(); //模拟在按钮上的一次鼠标单击
							URL.revokeObjectURL(linkNode.href); // 释放URL 对象
							document.body.removeChild(linkNode);
						} else {
							that.$message.error(res.msg)
						}
					}
				)
			},
			handleSizeChange() {
				this.getList()
			},
			handleCurrentChange() {
				this.getList()
			},
			// 排序规则变更
			handleSortChange({
				prop,
				order
			}) {
				this.defaultSort.prop = prop
				this.defaultSort.order = order

				this.$nextTick(() => {
					this.getList()
				})
			},
			// Safari 中 table 列同时启用 width 和 show-overflow-tip 时
			// el-tooltip 未正确设置 width 行内样式, Safari 不兼容 col 列设置的宽度
			// 内容过长时, 会导致撑开列宽
			getCellStyle({
				column
			}) {
				const tempWidth = column.realWidth || column.width
				if (column.showOverflowTooltip) {
					return {
						minWidth: tempWidth + 'px',
						maxWidth: tempWidth + 'px',
					}
				}
				return {}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.page {
		background-color: white;
	}

	@media screen and (max-width: 1998px) {
		.search-form {
			max-width: 980px;
		}
	}

	@media screen and (max-width: 1113px) {
		.search-form {
			max-width: 444px;
		}
	}

	@media screen and (max-width: 723px) {
		.search-form {
			max-width: 312px;
		}
	}

	.searchbar {

		.el-date-editor--daterange.el-input,
		.el-date-editor--daterange.el-input__inner {
			width: 228px;
		}

		.table-toolbar-btn {
			margin-left: 0;
			margin-right: 10px;
			margin-bottom: 10px;
		}
	}

	.el-table__body {
		width: 100% !important;
		table-layout: fixed !important;
	}

	/deep/ .sortable-column {
		padding-left: 5px !important;
		padding-right: 5px !important;
	}

	/deep/ .sortable-column-header {
		padding-left: 0 !important;
		padding-right: 0 !important;
	}

	.search-btn {
		float: unset !important;
		border: none;
		padding: 0 !important;
		margin: 0 !important;
		margin-left: 10px !important;
		vertical-align: top;
	}

	.refresh-btn {
		width: 32px;
		height: 32px;
		border: none;
		color: #117FFC;
		padding: 0;
		background-color: rgba(17, 127, 252, 0.2);
		font-weight: bold;
		font-size: 22px;
		vertical-align: 8px;
		margin-left: 5px;

		&:hover {
			background-color: rgba(17, 127, 252, 0.3);
		}
	}

</style>
